import type { ADFEntity } from '@atlaskit/adf-utils/types';

export const MAX_SNIPPET_NAME_LENGTH = 60;
export const MAX_SNIPPET_DESCRIPTION_LENGTH = 120;

const EMPTY_ADF = { type: 'doc' as const, version: 1 as const, content: [] };

/**
 * Form values for snippet modals (Create/Edit/Duplicate).
 * Shared by SnippetBaseModal and the three mode modals.
 */
export type SnippetBaseModalFormValues = {
	snippetName: string;
	snippetDescription: string;
	/** Only present when site sharing is enabled. true = Shared, false = Private. Not sent to BE. */
	isShared?: boolean;
};

/**
 * Normalizes ADF to a doc node for preview/editor.
 * Handles undefined, array, or single node.
 */
export function normalizeToDoc(adf: ADFEntity | ADFEntity[] | undefined): {
	type: 'doc';
	version: 1;
	content: any[];
} {
	if (!adf) {
		return EMPTY_ADF;
	}
	if (Array.isArray(adf)) {
		return { type: 'doc', version: 1, content: adf };
	}
	if (adf.type === 'doc' && Array.isArray(adf.content)) {
		return { type: 'doc', version: 1, content: adf.content };
	}
	return { type: 'doc', version: 1, content: [adf] };
}

/**
 * Returns base form values only. Each modal overrides the fields it needs.
 */
export function getDefaultFormValues(includeSharingField: boolean): SnippetBaseModalFormValues {
	const values: SnippetBaseModalFormValues = {
		snippetName: '',
		snippetDescription: '',
	};
	if (includeSharingField) {
		values.isShared = false;
	}
	return values;
}
